module.exports = __webpack_public_path__ + "static/media/lock.0a68373d.png";